import React, { Component, createRef } from "react";
import PropTypes from "prop-types";

class ContentEditable extends Component {
  constructor(props) {
    super(props);
    this.elem = createRef();
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.elem.current.focus();
    }
  }

  componentDidUpdate() {
    if (this.props.value !== this.elem.current.innerText) {
      this.elem.current.innerText = this.props.value;
      this.elem.current.blur();
    }

    if (this.props.autoFocus) {
      this.elem.current.focus();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.value !== this.elem.current.innerText ||
      nextProps.editable !== this.props.editable
    );
  }

  onChange = event => {
    const { onChange } = this.props;
    const value = this.elem.current.innerText;

    onChange && onChange(event, value);
  };

  render() {
    const { node, value, editable, placeholder } = this.props;
    const Element = node || "div";

    return (
      <Element
        ref={this.elem}
        contentEditable={editable}
        onInput={this.onChange}
        placeholder={placeholder}
        suppressContentEditableWarning={true}
      >
        {value}
      </Element>
    );
  }
}

ContentEditable.propTypes = {
  node: PropTypes.object,
  value: PropTypes.string,
  editable: PropTypes.bool.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool
};

export default ContentEditable;
